import axios from "axios";

import { auth } from "@Firebase/firebase";

import {
  TitleIssue,
  LienInfo,
  TitleIssueStatusCounts,
} from "@Types/title_issues";
import { HttpQuery, PaginatedResult } from "@Types/http";

export const getTitleIssues = (
  query?: HttpQuery
): (() => Promise<PaginatedResult<TitleIssue[]>>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/title_issue/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return {
      docs: response.data.result?.docs ?? [],
      totalDocs: response.data.result?.totalDocs ?? 0,
      totalPages: response.data.result?.totalPages ?? 0,
    };
  };
};

export const getTitleIssueStatusCounts = (): (() => Promise<TitleIssueStatusCounts>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/title_issue/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query: JSON.stringify({ countsOnly: true }),
        },
      }
    );

    return response.data.result;
  };
};

export const getTitleIssue = (id: string): (() => Promise<TitleIssue>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/title_issue/${id}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};
export const forceTitleIssueCheck = (): ((
  request: TitleIssue & { state: string }
) => Promise<TitleIssue>) => {
  return async (request) => {
    try {
      const token = await auth.currentUser?.getIdToken();

      const response = await axios.post(
        `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/force_title_issue_check/`,
        request,
        {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.result;
      // eslint-disable-next-line
    } catch (err: any) {
      throw new Error(
        err?.response?.data?.message ??
          err?.response?.data?.result ??
          err?.message ??
          "Unknown error!"
      );
    }
  };
};

export const saveWiLienResult = (): ((request: {
  titleIssueId: string;
  hasLien: boolean;
  lienholderName?: string | null;
  lienholderAddress?: string | null;
  receivedDate?: string | null;
}) => Promise<LienInfo>) => {
  return async (request) => {
    try {
      const token = await auth.currentUser?.getIdToken();
      const response = await axios.post(
        `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/wi_lien_save`,
        request,
        {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.result;
    } catch (err: unknown) {
      if (axios.isAxiosError(err)) {
        throw new Error(
          err.response?.data?.message ??
            err.response?.data?.result ??
            err.message ??
            "Unknown error!"
        );
      }
      throw new Error(
        err instanceof Error ? err.message : "Unknown error!"
      );
    }
  };
};
